import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { BiSmile } from 'react-icons/bi';
import { CgSmileSad } from 'react-icons/cg';
import { CgSmileNone } from 'react-icons/cg';
import { TiInfo } from 'react-icons/ti';
import { IoMdDoneAll } from 'react-icons/io';
import { MdError } from 'react-icons/md';
import { connect } from 'react-redux';

import { setPublishNotificationSummary } from 'redux/urls/url.action';

import 'react-toastify/dist/ReactToastify.css';
import './publishNotification.style.css';


const PublishNotification = ({ publishNotificationSummary, setPublishNotificationSummary }) => {

  const notify = () => {
    if (publishNotificationSummary.published != 0) {
      toast.success(
        <div className='notification'>
          <IoMdDoneAll className='notification-icon' />
           Published {publishNotificationSummary.published} {publishNotificationSummary.published == 1 ? 'URL' : 'URLs'} succesfully!
          <BiSmile className='smile-happy' />
        </div>,
        { autoClose: 6000 });
    };
    if (publishNotificationSummary.unpublished != 0) {
      toast.error(
        <div className='notification'>
          <MdError className='notification-icon' />
          {publishNotificationSummary.unpublished} {publishNotificationSummary.unpublished == 1 ? 'URL' : 'URLs'} failed to publish.
          <CgSmileSad className='smile-sad' />
        </div>,
        { autoClose: 6000 });
    };
    if (publishNotificationSummary.published == 0) {
      toast.info(
        <div className='notification'>
          <TiInfo className='notification-icon' />
          {publishNotificationSummary.published} {publishNotificationSummary.published == 1 ? 'URL' : 'URLs'} Published.
          <CgSmileNone className='smile-nutral' />
        </div>,
        { autoClose: 6000 });
    };
  };

  useState(() => {
    notify();
    setPublishNotificationSummary(null);
  }, []);

  return (
    <ToastContainer />
  );
};


const mapDispatchToProps = dispatch => ({
  setPublishNotificationSummary: summary => dispatch(setPublishNotificationSummary(summary))
});

export default connect(null, mapDispatchToProps)(PublishNotification);
